
namespace Gamification.Gamification {
    export class ProdottiClassiAssetEsperienzeColumns {
        static columnsKey = 'Gamification.ProdottiClassiAssetEsperienze';
    }
}